import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import DistributionNavigation from '../DistributionNavigation'
import Button from '../../../UniformComponents/Button'
import DistributeEmptyState from '../../../UniformComponents/DistributeEmptyState'
import Panel from '../../../UniformComponents/Panel'
import DataTable from '../../DataTable'
import CampaignLinksModal from '../CampaignLinks/CampaignLinksModal'
import KioskSettingsModal from './KioskModeModal'
import DeleteModal from '../Modal/DeleteModal'
import Typography from '../../../UniformComponents/Typography'

@observer
class OnSiteApp extends Component {
    constructor(props) {
        super(props)

        const { distributeStore } = props

        if (distributeStore.isRapidSurvey()) {
            distributeStore.goToCampaignLinks()
        }

        distributeStore.campaignType = 'onsite'
        distributeStore.getCampaigns('onsite')
    }

    getColumns = () => {
        const { distributeStore, store } = this.props
        const { survey } = store

        return [
            {
                key: 'campaigntitle',
                name: 'Title',
                dataTransform: (value, row) => (
                    [
                        <Typography type="b">{value}</Typography>,
                        <div key={`fc_${value}`} className="campaign-links-link-input">
                            <i className="far fa-link-horizontal" />

                            <Typography type="tiny">
                                {survey.getCampaignLink(row.uuid, row.langCode, store.useLatestUI)}
                            </Typography>
                        </div>,
                    ]
                ),
            },
            {
                key: 'campaignId',
                name: '',
                dataTransform: (_, row) => (
                    <div className="campaign-links-table-actions">
                        <i className="fal fa-edit" onClick={(e) => distributeStore.editCampaign(e, row)} />
                        <i className="fal fa-circle-xmark" onClick={() => distributeStore.showDeleteModal(row.campaignId)} />
                    </div>
                ),
                cellClass: 'center w50 pointer',
            },
        ]
    }

    render() {
        const { distributeStore, store } = this.props
        const { filteredList } = distributeStore
        const { survey } = store

        return (
            <div className="email-landing-content">
                <DistributionNavigation store={distributeStore} survey={store.survey} />

                <div className="email-landing-right-container">
                    <Panel style={{ padding: 20, overflow: 'visible' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h2>{i18n.t('distributionOnsite.title')}</h2>

                            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                <Button
                                    cssClass="regular tertiary"
                                    onClick={distributeStore.showKioskSettingsModal}
                                    icon="fal fa-gear"
                                    label={i18n.t('distributionOnsite.kioskSettings')}
                                />

                                <Button
                                    cssClass="regular tertiary"
                                    onClick={distributeStore.showCampaignModal}
                                    icon="fal fa-link"
                                    label={i18n.t('distributionOnsite.create')}
                                />
                            </div>
                        </div>
                    </Panel>

                    {!filteredList.length && !distributeStore.filterText.length
                        ? (
                            <DistributeEmptyState
                                title={i18n.t('distributionOnsite.emptyStateText')}
                                subtext={i18n.t('distributionOnsite.emptyStateSubText')}
                                ctaText={i18n.t('distributionOnsite.create')}
                                icon="fal fa-tablet-screen"
                                ctaIcon="fal fa-link-horizontal"
                                onClick={distributeStore.showCampaignModal}
                            />
                        ) : (
                            <Panel style={{ padding: 0 }}>
                                <DataTable
                                    store={distributeStore}
                                    dataSet={filteredList}
                                    inMemory
                                    columns={this.getColumns()}
                                />
                            </Panel>
                        )}
                </div>

                <CampaignLinksModal distributeStore={distributeStore} />

                <KioskSettingsModal distributeStore={distributeStore} survey={survey} />

                <DeleteModal distributeStore={distributeStore} />
            </div>
        )
    }
}

export default OnSiteApp
